import styled from 'styled-components';
import { DefaultBox } from '../../theme/Boxes.style';
import { IonPage, IonToolbar } from '@ionic/react';
// import { checkmarkOutline } from 'ionicons/icons';

type PsychologistListIonPageProps = {
  isIos: boolean;
};

export const PsychologistListIonPage = styled(IonPage)<PsychologistListIonPageProps>`
  div {
    overflow: auto !important;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

type StyledVerifyUkrainianWrapperPropsType = {
  isIos: boolean;
  isInternetConnection: boolean;
};

export const StyledVerifyUkrainianWrapper = styled(DefaultBox)<StyledVerifyUkrainianWrapperPropsType>`
  margin-top: ${(props) =>
    props.isIos ? (props.isInternetConnection ? '44px' : '74px') : props.isInternetConnection ? '0' : '30px'};
  @media (min-width: 600px) {
  }
  padding: 0 16px 16px !important;
`;

type StyledVerifyUkrainianContainerPropsType = {
  isFinancialSupportApproved: boolean;
};

export const StyledVerifyUkrainianContainer = styled.div<StyledVerifyUkrainianContainerPropsType>`
  max-width: 375px;
  @media only screen and (min-width: 768px) {
    max-width: 436px;
  }
  margin-left: auto;
  margin-right: auto;
  padding: 16px;
  background-color: ${(props) => (props.isFinancialSupportApproved ? '#F1FFEB' : '#f7f9fe')};
  box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

export const StyledInfoWrapper = styled.div`
  width: 220px;
  display: flex;
  flex-direction: column;

  div {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
  }

  span {
    text-align: center;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }

  a {
    display: block;
    margin-top: 12px;
    justify-self: flex-end;
    max-width: max-content;
    text-decoration: none;

    div {
      padding: 7px 20px;
      background-color: #177590;
      border-radius: 4px;
      text-align: center;
      color: white;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const StyledImageWrapper = styled.div`
  img {
    width: 89px;
    height: 89px;
  }
`;

export const StyledTextWithIconWrapper = styled.div`
  margin-top: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledSuccessIconWrapper = styled.div`
  margin-right: 5px;
  height: 28px;
  width: 28px;
  border-radius: 999px;
  background: #7ad221;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledContainerForIonToolbar = styled(IonToolbar)`
  @media (min-width: 600px) {
    padding-left: calc((100vw - 468px) / 2);
    padding-right: calc((100vw - 468px) / 2);
  }
  @media (min-width: 1024px) {
    padding-left: calc((100vw - 960px) / 2);
    padding-right: calc((100vw - 960px) / 2);
  }
`;

export const PsychologistListContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;

  .empty-search {
    height: 50vh;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;

    .h3 {
      font-weight: 600;
      font-size: 20px;
      line-height: 24px;
      text-align: center;
      margin-bottom: 2em;
    }

    .cancel-btn {
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: #c13e18;
      padding: 4px;
    }
  }
`;

type FavouritesHeaderProps = {
  isDesktop?: boolean;
};

export const FavouritesHeader = styled.button<FavouritesHeaderProps>`
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;
  right: 0px;
  display: flex;
  color: #1d201f;

  ion-icon {
    align-self: center;
    font-size: 24px;
    cursor: pointer;
    position: relative;
  }

  .badge {
    border-radius: 50%;
    background: #c13e18;
    top: 8px;
    right: 4px;
    position: absolute;
    width: 7px;
    height: 7px;
  }
`;

export const BalanceContainer = styled.div`
  display: grid;
  gap: 2px;
  padding-right: 15px;
  padding-left: 5px;
`;

export const BalanceHeading = styled.h4`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: right;

  color: #1d201f;
`;

export const BalanceSubHeading = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  text-align: right;
  color: #5b5b5b;
`;
